import { AxiosHeaders } from 'axios'
import React, { useEffect, useState } from 'react'
import { BsCheck2Circle } from 'react-icons/bs'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import useUser from '../../Context/hook/useUser'
import { getRequest, loadSessionUser, postRequest } from '../../Services/axios.service'
import { CONFIRM_EMAIL, REFRESH } from '../../Utils/url.api'

export const ConfirmEmail = () => {
    const params = useParams()
    const navigate = useNavigate()
    const [ token, setToken ] = useState(params.token)
    const [ verified, setVerified ] = useState()
    const { isAuth, login } = useUser()

    useEffect(() => {
        verifyEmail()
    }, [])

    const verifyEmail = async() => {
        if(!token) navigate('/')
        else {
            const headers = {
                Authorization: `Bearer ${loadSessionUser()}`,
            };
            await toast.promise(getRequest(`${CONFIRM_EMAIL}?token=${token}`, {headers} ), {
                
                pending: {
                    position: 'top-center',
                    type: 'default',
                    isLoading: true,
                    icon: false,
                    render: () => 'Espere'
                },
            }).then(({data}) => {
                if(data.valid) {
                    setVerified(ver => data.valid)
                }
                else {
                    toast(`Ha ocurrido un error, mensaje: ${data.message}`, {
                        theme: 'colored', type: 'error'
                    })
                    setTimeout(() => {
                        navigate('/')
                    }, 1000)
                }
            })
        }
    }

    const redirect = () => {
        isAuth() ? refreshLogin() : navigate('/login')  
    }

    const refreshLogin = async() => {
        const headers = {
            Authorization: `Bearer ${loadSessionUser()}`,
        };
        const {data} = await postRequest(REFRESH, {}, {headers})
        if(data?.accessToken) 
        {
            const { accessToken, expireAt } = data
            login(accessToken, expireAt)
            navigate("/")
        }
        else navigate('/login')
    }
    

    return (
        <> 
        {!verified ? 
            <div className='text-lg flex justify-center'>
                <div className="pulse-loading"></div>
                <ToastContainer></ToastContainer>
            </div>
        :
            <div className='text-lg'>
                <div className="flex justify-center">
                    <BsCheck2Circle className='text-[10rem] text-success'></BsCheck2Circle>
                </div>
                <div className="text-font-primary my-12">
                    <p className='text-2xl pb-8'>¡TE DAMOS LA BIENVENIDA!</p>
                    Tu cuenta ha sido verificada correctamente.
                </div>
                <div className="">
                    <button className='w-[50%] uppercase rounded-[20rem] bg-primary text-xl rounded px-8 py-4 text-white'
                        onClick={() => redirect()}>
                        Aceptar
                    </button>
                </div>
                <hr className='my-8 border-bd-primary'></hr>
                <ToastContainer></ToastContainer>
            </div>
        }
            
        </>
    )
}
